/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import { Checkbox, List, Box } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { Button, Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import InputAdornment from '@mui/material/InputAdornment';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { onCellFocused } from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  rebatePricingDetails,
  priceDetailsHeaders,
} from '../gridComponents/tableHeaders';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  redirectURLLink,
  checkQuarterValidation,
  closeTab,
  compareQtrs,
  convertQuaterToDate,
  handleExistingCommentList
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
  END_QTR_ERROR,
  LEVEL_ID_ERR,
  START_QTR_ERR,
  END_QTR_ERR,
  LEVELID_ERR,
  SUCCESSMESSAGE_GENERIC,
  ERR_PAGINATE_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import {
  getMaintanancePriceGridDetails,
  dispatchPageCountwithDetails,
  getNdcDetailsCall,
  storeUpdatedDetailsPage,
  saveMaintainPriceDetails,
  storePriceDetailsErrors,
  showAllQuarters,
  deletedUpdatedRow,
  storeUpdatedList,
  dispatchMaintanancePriceDetails,
  getMaintanancePriceHeaderDetails,
  dispatchMaintanancePriceGridDetails,
  onChangePage,
  errorControl,
  storeAllListed,
  onchangePayloadData,
  updateMaintainPriceDetails,
} from '../store/actions';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import {
  setCurrentNDCDetailsSelected,
  setCurrentNDCDetailsIndex,
} from '../../../Display/NDC/store/action';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../Manufacturer/store/ManufacturerAction';
import { getDrugFamilyDetails } from '../../DrugFamily/DrugFamilySearch/store/actions';
import { createFlag } from '../../DrugFamily/DrugFamilyDetails/store/actions';
import * as actionType from '../../DrugFamily/DrugFamilySearch/store/actionTypes';
import { selectedType, dispatchCellClick } from '../../Contract/store/actions';
import {
  quarterOverlapValidation,
  startQtrValidation,
} from '../../RebatePriceLevel/Components/utils';
import { isStartQtrGreater, isStartQtrValid, isEndQtrValid } from './utils';
import { getRebatePgmDetail } from '../../RebateProgram/SearchRebate/store/actions';
import { tabValue } from '../../RebateProgram/MaintainRebate/store/actions';
import { autoFormateDate, tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import { getExistingCorrLinkIds } from '../../../Research/InvoiceAudits/store/Actions';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';

const RebatePriceDetails = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [fullScreenView1, setFullScreenView1] = React.useState(false);
  const [fullScreenView2, setFullScreenView2] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [buttonDisable, setButtonDisable] = React.useState({
    save: true,
    cancel: true,
  });
  const gridRef = React.useRef();
  const [totalCount, setTotalCount] = React.useState(0);
  const [movePage, setMovePage] = React.useState(false);
  const [moveRight, setMoveRight] = React.useState(false);
  const [claimPageDetails, setClaimPageDetails] = React.useState();
  const [disableBtn, setDisableBtn] = React.useState(false);
  const [rebateProgramMethod, setRebateProgramMethod] = React.useState([]);
  const [quarterData, setQuarterData] = React.useState('');
  const [jumbPopup, seJumbPopup] = React.useState(false);
  const [allNdcList, setAllNdcList] = React.useState([]);
  const [jumbNdc, setJumbNdc] = React.useState();
  const [rowValues, setRowValues] = React.useState([]);
  const [onblur, setOnblur] = React.useState(0);
  const [deletePopup, setDeletePopup] = React.useState(false);
  const [deletedRowInfo, setDeletedRowInfo] = React.useState();
  const [updateTable, setUpdateTable] = React.useState(false);
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(true);
  const [keyValue, setKeyValue] = React.useState([]);
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [tableName, setTableName] = React.useState('CONTRACT_DRUG_FAMILY');
  const [linkTableName, setLinkTableName] = React.useState(
    'REBATE_PRICING_DETAIL'
  );
  const [stateCC, setStateCC] = React.useState(true);
  const [tableGridApi, setTableGridApi] = React.useState([]);
  const [gridApi, setGridApi] = React.useState(null);
  const [amtFormat, setAmtFormat] = React.useState(false);
  const [typeVal, setTypeVal] = React.useState({
    startQtr: '',
    endQtr: '',
    name: '',
  });
  const [sampleError, setSampleError] = React.useState(false);
  const [inputValues, setInputValues] = React.useState();
  const [test, setTest] = React.useState(false);
  const {
    headerPriceDetails,
    getPriceGridDetails,
    pageCountwithDetails,
    savePriceDetails,
    showQuartes,
    store_updated_list,
    onchangePayload,
  } = useSelector((state) => state.sharedState.PriceDetails);

  const updatedPage = useSelector(
    (state) => state?.sharedState?.PriceDetails?.storeUpdatedDetailsPage
  );

  const onChangeInfo = useSelector(
    (state) => state?.sharedState?.PriceDetails?.UpdatedPage
  );

  const deletedUpdatepage = useSelector(
    (state) => state?.sharedState?.PriceDetails?.deletedUpdatepage
  );

  const drug_family_details = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.drug_family_details
  );

  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );

  const getErrorMsgs = useSelector(
    (state) => state.sharedState.PriceDetails.priceDetailErrors
  );

  const logInUserID = useSelector((state) => state.sharedState.logInUserID);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const getInputValues = useSelector(
    (state) => state.sharedState.PriceDetails.priceLevelSearchdata
  );

  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });

  React.useEffect(() => {
    if (onChangeInfo && getErrorMsgs) {
      if (getErrorMsgs?.length > 0) {
        const errMsg = getErrorMsgs?.map((data) => data?.message);
        setButtonDisable((prev) => ({
          ...prev,
          save: true,
          cancel: true,
        }));
        setErrorMessages(errMsg);
      } else {
        setButtonDisable((prev) => ({
          ...prev,
          save: false,
          cancel: false,
        }));
        setErrorMessages([]);
      }
    }
  }, [getErrorMsgs, onChangeInfo]);

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsgs && getErrorMsgs.length > 0) {
      tabHighLigther('/rebatePriceDetails', true);
    } else {
      tabHighLigther('/rebatePriceDetails', false);
    }
  }, [JSON.stringify(getErrorMsgs)]);

  // set full screen click icon button
  const handleFullScreenView = (key) => {
    if (key === 1) {
      setFullScreenView1(!fullScreenView1);
    } else {
      setFullScreenView2(!fullScreenView2);
    }
  };

 const getTableList = (data) => {
  if (data) {
    dispatch(
      getMaintanancePriceGridDetails({
        qtr: data?.asQtr,
        contractSeqNum: data?.contractSeqNum,
        familySeqNum: data?.familySeqNum,
        drugSeqNum: data?.drugSeqNum,
      })
    );
    setOpenCancel(false);
  }
};


  // Call Pagination API on page count change
  React.useEffect(() => {
    let count = 1;
    if (pageCountwithDetails) {
      setClaimPageDetails(pageCountwithDetails);
      //   setLoading(true);
      count = pageCountwithDetails?.pageCount;
    }
    if (
      headerPriceDetails?.status === '001' &&
      headerPriceDetails?.rebatePriceDetailsHeaderResponseVO
        ?.maintainRebateProgramHeaderVO?.length > 0
    ) {
      getTableList(
        headerPriceDetails?.rebatePriceDetailsHeaderResponseVO
          ?.maintainRebateProgramHeaderVO[count-1]
      );
    }
  }, [pageCountwithDetails, headerPriceDetails]);

  React.useEffect(() => {
    if (getPriceGridDetails?.message === 'SUCESS') {
      let maintainRebateProgram = [];
      maintainRebateProgram =
        getPriceGridDetails?.maintainPriceDetailsResponseVO?.maintainRebateProgramGridVO.map(
          (data) => {
            return {
              rebatepricingmethod: data.rebatePricingMethodCd,
              valumecalcmethod: data.volumeCalcMethodCd,
              marketsharecalcmethod: data.mktShareCalcMethodCd,
              nationalmarketshareprice: data.natMktShareTypeCd,
            };
          }
        );
      setRebateProgramMethod(maintainRebateProgram);
    }
  }, [getPriceGridDetails]);

  // FETCH BOTH GRIDS
  React.useEffect(() => {
    if (getPriceGridDetails) {  
      let maintainRebatePriceLevel = [];
      maintainRebatePriceLevel =
        getPriceGridDetails?.maintainPriceDetailsResponseVO?.maintainRebateProgramLevelGridVO.map(
          (data, index) => {
            return {
              ...data,
              levelId: data.levelId,
              amt: data.amt,
              startQtr: data.startQtr,
              endQtr: data.endQtr,
              contractFamilySeqNum: data.contractFamilySeqNum,
              rowIndex: index,
              lastUpdateUserId: logInUser,
              deleteRecord: 0,
              claimCorrLinkId: data?.corrLinkId,
              corrLinkId: data?.corrLinkId,
            };
          }
        );
         dispatch(
          storeUpdatedDetailsPage({
            ...updatedPage,
            [pageCountwithDetails?.pageCount]: maintainRebatePriceLevel,
          })
        );
        
      if (!updatedPage[pageCountwithDetails?.pageCount]) {
        // setRowValues((prev) => ({ ...prev, [pageCountwithDetails?.pageCount]: temp }));
        dispatch(
          storeUpdatedDetailsPage({
            ...updatedPage,
            [pageCountwithDetails?.pageCount]: maintainRebatePriceLevel,
          })
        );
        if (!store_updated_list) {
          dispatch(
            storeUpdatedList({
              ...updatedPage,
              [pageCountwithDetails?.pageCount]: maintainRebatePriceLevel,
            })
          );
       }
      } else if (updateTable || maintainRebatePriceLevel?.length === 0) {
        dispatch(
          storeUpdatedDetailsPage({
            ...updatedPage,
            [pageCountwithDetails?.pageCount]: maintainRebatePriceLevel,
          })
        );
      }
      handleExistingCommentList(maintainRebatePriceLevel);

    }
  }, [getPriceGridDetails, pageCountwithDetails, updateTable]);

  React.useEffect(() => {
    setUpdateTable(false);
  }, [updatedPage]);

  React.useEffect(() => {
    if (headerPriceDetails?.status === '001') {
      setTotalCount(
        headerPriceDetails?.rebatePriceDetailsHeaderResponseVO
          ?.maintainRebateProgramHeaderVO?.length
      );
      if (pageCountwithDetails) {
        dispatch(
          dispatchPageCountwithDetails({
            pageCount: pageCountwithDetails?.pageCount,
            inputList: pageCountwithDetails?.inputList,
            rowsChanged: pageCountwithDetails?.rowsChanged,
            // deletedRows: pageCountwithDetails.deletedRows[pageCountwithDetails?.pageCount] || [],
          })
        );
      } else {
        dispatch(
          dispatchPageCountwithDetails({
            pageCount: 1,
            inputList:
              headerPriceDetails?.rebatePriceDetailsHeaderResponseVO
                ?.maintainRebateProgramHeaderVO[0],
            rowsChanged: false,

            // deletedRows: {[1]: []},
          })
        );
      }

      const list =
        headerPriceDetails?.rebatePriceDetailsHeaderResponseVO?.maintainRebateProgramHeaderVO?.map(
          (data, index) => {
            const { labelerCode, productCode, packageSize } = data;
            return {
              id: index + 1,
              value: `${labelerCode}-${productCode}-${packageSize}`,
            };
          }
        );
      setAllNdcList(list);
    }
  }, [headerPriceDetails]);

  React.useEffect(() => {
    dispatch(
      dispatchPageCountwithDetails({
        pageCount: 1,
        inputList:
          headerPriceDetails?.rebatePriceDetailsHeaderResponseVO
            ?.maintainRebateProgramHeaderVO[0],
        rowsChanged: false,
        deletedRows: { 1: [] },
      })
    );
  }, []);

  // Pagination right arrow click function
  const clickNextRow = () => {
    setSuccessMessages([]);
    const obj = {};
    obj.pageCount = claimPageDetails?.pageCount + 1;
    obj.inputList =
      headerPriceDetails?.rebatePriceDetailsHeaderResponseVO?.maintainRebateProgramHeaderVO[
        claimPageDetails.pageCount
      ];
    obj.rowsChanged = pageCountwithDetails?.rowsChanged;

    dispatch(dispatchPageCountwithDetails(obj));
    setMoveRight(false);
  };

  // Pagination left arrow click function
  const clickPrevious = () => {
    setSuccessMessages([]);
    const obj = {};
    obj.pageCount = claimPageDetails.pageCount - 1;
    obj.inputList =
      headerPriceDetails?.rebatePriceDetailsHeaderResponseVO?.maintainRebateProgramHeaderVO[
        claimPageDetails.pageCount - 2
      ];
    obj.rowsChanged = pageCountwithDetails?.rowsChanged;
    // obj.deletedRows = {[claimPageDetails.pageCount + 1]: claimPageDetails.deletedRows},

    dispatch(dispatchPageCountwithDetails(obj));
    setMovePage(false);
  };

  // Pagination input field change function
  const handlePage = (e) => {
    if (buttonDisable.save) {
      setSuccessMessages([]);
      const count = Number(e.target.value);
      setErrorMessages([]);

      const obj = {};
      obj.pageCount = count;
      obj.inputList =
        headerPriceDetails?.rebatePriceDetailsHeaderResponseVO?.maintainRebateProgramHeaderVO[
          count - 1
        ];

      if (count !== 0) {
        if (count <= totalCount) {
          setDisableBtn(false);
        } else {
          obj.pageCount = count;
          obj.inputList = claimPageDetails?.inputList;
          // obj.deletedRows = {[count]: claimPageDetails.deletedRows},

          setDisableBtn(true);
        }
      } else {
        obj.pageCount = 0;
        obj.inputList = claimPageDetails?.inputList;
        // obj.deletedRows = {[count]: claimPageDetails.deletedRows},

        setDisableBtn(true);
      }
      dispatch(dispatchPageCountwithDetails(obj));
    }
  };

  const openJumbNdc = () => {
    seJumbPopup(true);
  };

  const moveToNdc = () => {
    dispatch(
      dispatchPageCountwithDetails({
        pageCount: jumbNdc,
        inputList:
          headerPriceDetails?.rebatePriceDetailsHeaderResponseVO
            ?.maintainRebateProgramHeaderVO[Number(jumbNdc) - 1],
      })
    );
    seJumbPopup(false);
  };

  // Go to NDC redirection API Call
  const getNdcData = async () => {
    const response = await getNdcDetailsCall([
      {
        ndc: `${claimPageDetails?.inputList?.labelerCode}-${claimPageDetails?.inputList?.productCode}-${claimPageDetails?.inputList?.packageSize}`,
        drugName: claimPageDetails?.inputList?.drugName,
      },
    ]);
    if (response.message === 'SUCESS') {
      dispatch(setCurrentNDCDetailsSelected(response?.data[0], 'All'));
      redirectURLLink('/ndc-details', 'NDC Details', history, dispatch);
    }
  };
  const goToRebateProgram = () => {
    const request = {
      planType: claimPageDetails?.inputList?.planTypeCd,
      rebateProg: claimPageDetails?.inputList?.rpc,
    };
    dispatch(getRebatePgmDetail(request));
    dispatch(tabValue('one'));
    redirectURLLink(
      '/maintainRebate',
      'Maintain Rebate Program',
      history,
      dispatch
    );
  };

  const goToManufacturer = () => {
    dispatch(setSelectManufacturerData({}));
    dispatch(fetchAllManufacturerDetail(null));
    dispatch(getContactDetails(null));
    dispatch(maintainLabelerListData({}));
    dispatch(setMaintainManufacturerTab({}));
    const tempObj = {
      mfgId: claimPageDetails?.inputList?.mfgId,
    };
    tempObj.updateManufacturer = true;
    const result = dispatch(setSelectManufacturerData(tempObj));
    if (result && Object.keys(result).length > 0) {
      redirectURLLink(
        '/manufacturer-detail',
        'Maintain Manufacturer',
        history,
        dispatch
      );
    }
  };

  const goToContract = () => {
    dispatch(dispatchCellClick(true));
    dispatch(selectedType('MF'));
    searchContractState.contractType = 'onSelect';
    searchContractState.selectedContractType = 'mfgId';
    searchContractState.selectedRowData = claimPageDetails?.inputList?.mfgId;
    searchContractState.selectedContractId =
      getPriceGridDetails?.maintainPriceDetailsResponseVO?.maintainRebateProgramGridVO[0]?.contractSeqNum;
    searchContractState.searchContractState = null;
    searchContractState.getQuarter = claimPageDetails?.inputList?.asQtr;
    searchContractState.rebateProgramCode = claimPageDetails?.inputList?.rpc;
    searchContractState.planType = claimPageDetails?.inputList?.planTypeCd;
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/createContract',
      value: 'Maintain Contract',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    history.push({
      pathname: '/createContract',
    });
  };
  const goToDrugFamily = (cellInfo) => {
    dispatch(
      getDrugFamilyDetails({
        familySeqNum:
          getPriceGridDetails?.maintainPriceDetailsResponseVO
            ?.maintainRebateProgramGridVO[0]?.familySeqNum,
      })
    );
  };

  const handelSaveClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if (drug_family_details) {
      const { status, message } = drug_family_details;
      if (message === 'SUCESS' && status === '001') {
        dispatch({
          type: actionType.DRUG_FAMILY_DAETAILS,
          payload: null,
        });
        if (drug_family_details?.drugFamilyVOs?.length > 1) {
          dispatch({
            type: actionType.POPUP_TABLE_DATA,
            payload: drug_family_details.drugFamilyVOs,
          });
        } else {
          dispatch(createFlag(false));

          localStorage.setItem('updatedetails', true);
          redirectURLLink(
            '/drugFamilyDetail',
            'View Drug Family Details',
            history,
            dispatch
          );
        }
      }
    }
  }, [drug_family_details]);

  const startQtrValidations = (array = []) => {
    const temp = array.filter((item) => {
      if (item.startQtr === '') {
        dispatch(errorControl({ err: true }));
        return { startQtr: item.startQtr, endQtr: item.endQtr };
      }
    });
    return temp;
  };

  const levelValidation = (array = []) => {
    const temp = array.filter((item) => {
      if (item.levelId === '') {
        return { levelId: item.levelId };
      }
    });
    return temp;
  };

  const getErrData = (arr, field, error) => {
    const errlist = [];
    arr.filter((data, index) => {
      if (field === 'duplicateStartQtr') {
        errlist.push({
          field: field,
          message: `${error} for row ${data}`,
          index: data,
        });
      } else if (field === 'startDateGreater') {
        errlist.push({
          field: field,
          message: `${error} for row ${data.rowIndex + 1}`,
          index: data.rowIndex + 1,
        });
      } else if (
        field === 'invalidStartQtr' || field === 'invalidEndQtr' ? !data : data
      ) {
        errlist.push({
          field: field,
          message: `${error} for row ${index + 1}`,
          index: index + 1,
        });
      }
    });

    return errlist;
  };

  const checkingDuplicate = (array = []) => {
    const test = [];
    array.filter((data, index) => {
      array.filter((li) => {
        if (li.startQtr === data.startQtr && li.endQtr === data.endQtr) {
          test.push(index + 1);
        }
      });
    });

    const result = new Set(
      test.filter((item, index) => test.indexOf(item) !== index)
    );

    return Array.from(result);
  };

   const doQuartersOverlap = (dates) => {
    let myArr = [...dates];
    myArr = myArr.map((el) => {
      if (!el.endQtr) {
        return {
          ...el,
          startQtr: new Date(el.startQtr),
          endQtr: new Date('12/31/9999'),
        };
      }
      return {
        ...el,
        startQtr: new Date(el.startQtr),
        endQtr: new Date(el.endQtr),
      };
    });
    let overlap = [];

    for (let i = 0; i < myArr.length; i++) {
      for (let j = i + 1; j < myArr.length; j++) {
        // Check if the date ranges overlap
        if (
          myArr[i].drugfamilyname === myArr[j].drugfamilyname &&
          myArr[i].startQtr <= myArr[j].endQtr &&
          myArr[j].startQtr <= myArr[i].endQtr
        ) {
          // Add the indexes of the overlapping objects to the array
          overlap.push(i, j);
        }
      }
    }
    return (overlap = [...new Set(overlap)]);
  };

  const validations = () => {
    const array = rowValues[pageCountwithDetails?.pageCount] || [];
    let localErr = [];
    const dulplicateList = checkingDuplicate(array);
    const isLevel = levelValidation(array);
    const isStartQtr = startQtrValidations(array);
    const isStartQtrValid__ = isStartQtrValid(array, true);
    const isEndQtrValid__ = isEndQtrValid(array, true);

    const test = [];
    const temp = array?.filter((item) => {
      if (item?.endQtr && item?.startQtr) {
        return compareQtrs(item.startQtr, item.endQtr);
      }
      return false;
    });
    let tempArr = [...array];
    tempArr = tempArr.map((el) => {
      return {
        ...el,
        startQtr: convertQuaterToDate(el.startQtr),
        endQtr: convertQuaterToDate(el.endQtr),
      };
    });

    const quarterOverlap = doQuartersOverlap(tempArr);

    if (onblur) {
      setOnblur(false);
    }
    if (quarterOverlap.length > 0) {
      const errlist = [];
      quarterOverlap.filter((data, index) => {
        errlist.push({
          field: 'quarterOverlap',
          message: `Error! You cannot have two overlapping pricing levels ${
            claimPageDetails?.inputList?.familyName
          } for Rebate Pricing Method: URA, Level: 1 for row ${data + 1}`,
          index: data + 1,
        });
      });
      localErr = [...localErr, ...errlist];
    } else {
      localErr = [];
    }

    if (isStartQtr.length > 0) {
      const errlist = [];
      isStartQtr.filter((data, index) => {
        if (data.startQtr === '' && data.endQtr !== '') {
          errlist.push({
            field: 'startQtr',
            message: `${START_QTR_ERR}  ${data.rowIndex + 1}`,
          });
        } else if (data.startQtr === '' && data.endQtr === '') {
          errlist.push({
            field: 'startQtr',
            message: `Start Qtr is a required field for row ${
              data.rowIndex + 1
            }`,
            index: data.rowIndex + 1,
          });
        }
      });
      localErr = [...localErr, ...errlist];
    }

    if (isLevel.length > 0) {
      const errlist = [];
      isLevel.filter((data, index) => {
        if (data.levelId === '') {
          errlist.push({
            field: 'levelId',
            index: data.rowIndex + 1,
            message: `${LEVELID_ERR}  ${data.rowIndex + 1}`,
          });
        }
      });
      localErr = [...localErr, ...errlist];
    }
    if (isStartQtrValid__.includes(false)) {
      localErr = [
        ...localErr,
        ...getErrData(
          isStartQtrValid__,
          'invalidStartQtr',
          constantMessageData.INVALID_QTR_ERR_MSG
        ),
      ];
    }

    if (isEndQtrValid__.includes(false)) {
      localErr = [
        ...localErr,
        ...getErrData(
          isEndQtrValid__,
          'invalidEndQtr',
          constantMessageData.INVALID_QTR_ERR_MSG
        ),
      ];
    }

    if (temp.length > 0) {
      localErr = [
        ...localErr,
        ...getErrData(temp, 'startDateGreater', END_QTR_ERROR),
      ];
    }
    if (test.length > 0) {
      const errlist = [];
      test.filter((data, index) => {
        errlist.push({
          field: 'betweendate',
          message: `Error! You cannot have two overlapping pricing levels ${claimPageDetails?.inputList?.familyName} for Rebate Pricing Method: URA, Level: 1 for row ${data}`,
          index: data,
        });
      });
      localErr = [...localErr, ...errlist];
    }

    return localErr;
  };

  React.useEffect(() => {
    if (onblur) {
      const localErr = validations();
      dispatch(storePriceDetailsErrors(localErr));
    }
  }, [onblur, getErrorMsgs]);

  const getObjFormat = (data) => {
    return {
      drugSeqNum: data?.drugSeqNum,
      contractFamilySeqNum: data?.contractFamilySeqNum,
      startQtr: data?.startQtr,
      levelId: data?.levelId,
      endQtr: data?.endQtr,
      amt: data?.amt,
      lastUpdateUserId: data?.lastUpdateUserId,
      deleteRecord: 0,
    };
  };
  const gridTwoOnBlur = async (e, cellInfo, arrList, payload) => {
    setSuccessMessages([]);
    const name = cellInfo.column.colId;
    let { value } = e.target;
    const storeValues =
      arrList?.maintainPriceDetailsResponseVO?.maintainRebateProgramLevelGridVO;
    let array1 = payload?.rebatePriceDetailVO;
    let array2 = payload?.delRebatePriceDetailVO;
    if (name === 'levelId') {
      if (
        payload?.rebatePriceDetailVO
          .map((data) => data.rowIndex)
          .includes(cellInfo?.data?.rowIndex)
      ) {
        array1 = payload?.rebatePriceDetailVO.map((data) => {
          if (data.rowIndex === cellInfo?.data?.rowIndex) {
            return getObjFormat(cellInfo?.data);
          }
          return data;
        });
      } else {
        array1 = [...array1, getObjFormat(cellInfo?.data)];
        array2 = [
          ...array2,
          getObjFormat(
            storeValues.find(
              (data, index) => cellInfo?.data?.rowIndex === index
            )
          ),
        ];
      }
      dispatch(
        onchangePayloadData({
          rebatePriceDetailVO: array1,
          delRebatePriceDetailVO: array2,
        })
      );
    }
     if (name === 'startQtr' || name === 'endQtr'){
      value=(value || '').toUpperCase().trim();
       setQuarterData(value);
      cellInfo.node.setDataValue(name, value);
     }
    setTypeVal((prev) => ({
      ...prev,
      [name]: value,
      name: name,
    }));
    setOnblur(true);
    dispatch(onChangePage(true));
  };
  // add new row
  const AddRow = (page, count, contractNo) => {
    const contractSeq =
      contractNo?.maintainPriceDetailsResponseVO?.maintainRebateProgramGridVO[0]
        ?.contractFamilySeqNum;
    const newRow = {
      rowIndex: page[count]?.length,
      levelId:
        pageCountwithDetails?.inputList?.planTypeCd === 'SUPP' ? '1' : '',
      amt: '',
      startQtr: '',
      endQtr: '',
      drugSeqNum:
        headerPriceDetails?.rebatePriceDetailsHeaderResponseVO
          ?.maintainRebateProgramHeaderVO[count-1].drugSeqNum || '',
      contractFamilySeqNum: contractSeq,
      lastUpdateUserId: logInUserID ? logInUserID : logInUser,
      deleteRecord: 0,
      claimCorrLinkId: null,
    };

    const getRows = checkStartQtr([...page[count], newRow]);

    if (getRows?.length === 1) {
      dispatch(errorControl({ err: false }));
      dispatch(
        storeUpdatedDetailsPage({
          ...page,
          [count]: [...page[count], newRow],
        })
      );
      setSampleError(true);
      setRowValues({ [count]: [...page[count], newRow] });
      // setInputValues((prev) => ({ ...prev, rowsChanged: false }));
      setButtonDisable((prev) => ({
        ...prev,
        save: false,
        cancel: false,
      }));
    } else if (getRows?.length === 2) {
      setOnblur(true);
      dispatch(errorControl({ err: true }));
      validations([...page[count], newRow]);
      dispatch(onChangePage(true));
    }
  };

  const DeleteRow = (e, page, getValues) => {
    const count = getValues?.pageCount;
    const temp1 = [...page[count]];
    const temp2 = [...page[count]];
    // delete row
    const deleteRow_ = temp1.filter((item) => item.rowIndex !== e?.data?.rowIndex)
      .map((item, index) => {
        return {
          ...item,
          rowIndex: index, // updating index because of mismatch after delete
        };
      });
    dispatch(
      storeUpdatedDetailsPage({
        ...page,
        [count]: deleteRow_,
      })
    );
    // setOnblur(true)
    // validations(deleteRow_);
    dispatch(storePriceDetailsErrors([]));
    // store deleted rows
    let storeDeletedRows__ = [];
    storeDeletedRows__ = temp2
      .filter((item) => item.rowIndex === e.rowIndex)
      .map((item, index) => {
        // if(item.startQtr !== ''){
        return {
          ...item,
          deleteRecord: 1,
          rowIndex: index,
        };
        // }
      });
    const prevList =
      (deletedUpdatepage &&
        deletedUpdatepage[pageCountwithDetails?.pageCount]) ||
      [];
    const test = [...storeDeletedRows__, ...prevList];
    dispatch(
      deletedUpdatedRow({
        ...deletedUpdatepage,
        [pageCountwithDetails?.pageCount]: test,
      })
    );
    setDeletePopup(false);
    setButtonDisable((prev) => ({
      ...prev,
      save: false,
      cancel: false,
    }));
  };

  const onChangeGrid = (e, cellInfo) => {
    const name = cellInfo.column.colId;
    const { value } = e.target;

    const _11_6 = /^(?!$)\d{0,5}(?:\.\d{1,6})?$/; // for 11,6 chars
    const _15_6 = /^(?!$)\d{0,9}(?:\.\d{1,6})?$/; // for 15,6 chars
    cellInfo.node.setDataValue(name, value);
    dispatch(onChangePage(true));
    if (name === 'amt') {
      const obj = {};
      if (value && value.includes('.')) {
        const rx = /^[A-Za-z0-9]{0,9}(\.[A-Za-z0-9]{0,2})?$/;

        setAmtFormat(!rx.test(value));
      } else {
        const rx_without = /^[A-Za-z0-9]{0,9}?$/;
        setAmtFormat(!rx_without.test(value));
      }
    }

    if (false) {
    } else if (name === 'levelPct' || name === 'rebatePct') {
      if (
        _11_6.test(value) ||
        value.length === 0 ||
        value.split('.')[1]?.length === 0
      ) {
        cellInfo.node.setDataValue(name, value);
      }
    } else if (name === 'startQtr' || name === 'endQtr') {
      setQuarterData(value);
      cellInfo.node.setDataValue(name, value);
    } else {
      cellInfo.node.setDataValue(name, value);
    }
  };

  const onCellValueChanged = (e) => {
    const storeValues = [...updatedPage[pageCountwithDetails?.pageCount]];
    const name = e.column.colId;
    const { value } = e;
    if (name === 'levelId' || name === 'startQtr') {
      storeValues[e?.data?.rowIndex] = {
        ...storeValues[e?.data?.rowIndex],
        corrLinkId: null,
        [name]: value,
      };
    } else {
      storeValues[e?.data?.rowIndex] = {
        ...storeValues[e?.data?.rowIndex],
        [name]: value,
      };
    }
    // setInputValues((prev) => ({
    //   ...prev,
    //   rowsChanged: false,
    // }));
    setRowValues((prev) => ({
      ...prev,
      [pageCountwithDetails?.pageCount]: storeValues,
    }));
    // makeItDirty();
    // dispatch(storeUpdatedDetailsPage({ ...updatedPage, [pageCountwithDetails?.pageCount] : storeValues }));
  };

  const refreshDetails = async () => {
    const results = await getMaintanancePriceHeaderDetails({
      rpc: pageCountwithDetails?.inputList?.rpc,
      familyId: pageCountwithDetails?.inputList?.familySeqNum,
      mfg: pageCountwithDetails?.inputList?.mfgId,
      qtr: pageCountwithDetails?.inputList?.asQtr,
    });
    dispatch(storeAllListed(results));
    dispatch(
      dispatchPageCountwithDetails({
        pageCount: pageCountwithDetails?.pageCount,
        inputList: pageCountwithDetails?.inputList,
        rowsChanged: pageCountwithDetails?.rowsChanged,
        // deletedRows: pageCountwithDetails.deletedRows[pageCountwithDetails?.pageCount] || [],
      })
    );

    if (results?.status === '001') {
      dispatch(dispatchMaintanancePriceDetails(results));
    }
  };
  const saveDrugDetails = async (value) => {
    const prevList = deletedUpdatepage;

    const obj = {};
    const arrList = Array(Number(totalCount))
      .fill()
      .map((item, i) => (i + 1)?.toString());
    arrList.map((id, index) => {
      const arr1 = rowValues[id] ? rowValues[id] : updatedPage[id] || [];
      const arr2 = (deletedUpdatepage && deletedUpdatepage[id]) || [];
      obj[id] = [...arr1, ...arr2];
    });
    const temp1 = [];
    Object.keys(obj).filter((keys) => {
      const list1 = {};

      if (obj[keys].length > 0) {
        list1.maintainRebatePriceLevelGridVO = obj[keys].map((item) => {
          const objlist = {};
          objlist.drugSeqNum = item.drugSeqNum;
          objlist.contractFamilySeqNum = item.contractFamilySeqNum;
          objlist.levelId = item.levelId;
          objlist.amt = item.amt !== '' ? item.amt : null;
          objlist.startQtr = item.startQtr;
          objlist.endQtr = item.endQtr !== '' ? item.endQtr : null;
          objlist.lastUpdateUserId = item.lastUpdateUserId;
          objlist.deleteRecord = item.deleteRecord;
          if (objlist.startQtr !== '') {
            return objlist;
          }
        });
        const newarr = {};
        newarr.maintainRebatePriceLevelGridVO =
          list1?.maintainRebatePriceLevelGridVO?.filter((item) => {
            if (item) {
              return item;
            }
          });
        temp1.push(newarr);
      }
    });

    const data = {
      rebatePriceDetailsPaginationVO: temp1,
    };
    const result = await saveMaintainPriceDetails(data);

    if (result?.message === 'SUCESS') {
      if (!updatedPage) {
        setButtonDisable((prev) => ({
          ...prev,
          save: true,
          cancel: true,
        }));
      }
      setSuccessMessages([SUCCESSMESSAGE_GENERIC]);
      setButtonDisable((prev) => ({
        ...prev,
        save: true,
        cancel: true,
      }));
      dispatch(onChangePage(false));
      const resultGrid = await updateMaintainPriceDetails(onchangePayload);
      if (resultGrid?.message === 'SUCESS') {
        refreshDetails();
      }
      if (clickOncloseTabBtn) {
        setSuccessMessages([]);
        setErrorMessages([]);
        setButtonDisable((prev) => ({
          ...prev,
          save: true,
          cancel: true,
        }));
        dispatch(dispatchMaintanancePriceDetails([]));
        dispatch(dispatchMaintanancePriceGridDetails({}));
        dispatch(storeUpdatedDetailsPage({}));
        closeTab('/rebatePriceDetails', history);
      }
      setErrorMessages([]);
      setOpen(false);
      setClickOncloseTabBtn(true);
    }
  };

  const onBlurPage = () => {
    if (Number(pageCountwithDetails?.pageCount) !== 0) {
      const obj1 = {};
      if (Number(pageCountwithDetails?.pageCount) <= totalCount) {
        setErrorMessages([]);
        dispatch(storePriceDetailsErrors());
      } else {
        dispatch(
          storePriceDetailsErrors([
            {
              field: 'inputvaluetot count',
              message: INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
            },
          ])
        );
      }
    } else {
      dispatch(
        storePriceDetailsErrors([
          {
            field: 'input value total count',
            message: ERR_PAGINATE_VALUE,
          },
        ])
      );
    }
  };

  const validateQtr = (page, count, rowId) => {
    if (page[count]) {
      if (page[count][rowId]) {
        if (checkQuarterValidation(page[count][rowId].startQtr)) {
          return true;
        }
      }
      return false;
    }
    return false;
  };

  // Close Tab functionality
  React.useEffect(() => {
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/rebatePriceDetails';
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/rebatePriceDetails' && !buttonDisable.save) {
          item.isFormDirty = true;
        } else if (item.navTo === '/rebatePriceDetails')
          item.isFormDirty = false;
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [!buttonDisable.save]);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/rebatePriceDetails' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/rebatePriceDetails' && item.isFormSave) {
          item.isFormSave = false;
          saveDrugDetails(false);
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (
      showComments &&
      updatedPage[pageCountwithDetails?.pageCount] &&
      updatedPage[pageCountwithDetails?.pageCount].length > 0
    ) {
      setStateCC(false);
      updatedPage[pageCountwithDetails?.pageCount].map((item) => {
        if (
          item.corrLinkId === corrLinkId &&
          commentsList &&
          commentsList.length > 0
        ) {
          setStateCC(false);
          item.claimCorrLinkId = 1;
        } else if (item.corrLinkId === corrLinkId) {
          item.claimCorrLinkId = 0;
        }

        return item;
      });
      setStateCC(true);
      // eslint-disable-next-line no-unused-expressions
      tableGridApi?.api?.refreshCells();
    }
  }, [commentsList]);

  const onGridReady = (params) => {
    setGridApi(params.api);
    setTableGridApi(params);
    if (updatedPage[pageCountwithDetails?.pageCount]?.length > 0) {
      if (params?.api) {
        params.api.forEachNode(
          (node) => node?.rowIndex === 0 && node?.setSelected(true)
        );
      }
    }
  };

  const getLength = (key) => {
    if (key === 'startQtr' || key === 'endQtr') return 6;
    return 16;
  };
  const checkStartQtr = (list) => {
    const arr = list.filter((data) => {
      if (data.startQtr === '') {
        return data;
      }
    });
    return arr;
  };
  return (
    <div className=' tabs-container' data-testid='RebatePriceDetails'>
      <SaveCancelPopup
        open={open}
        data-testid='savePopup'
        title='Save'
        onConfim={() => {
          saveDrugDetails(true);
        }}
        onCancel={() => {
          handelSaveClose();
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        data-testid='cancelPopup'
        title='Cancel'
        onConfim={() => {
          refreshDetails();
          setButtonDisable((prev) => ({
            ...prev,
            save: true,
            cancel: true,
          }));
          dispatch(onChangePage(false));
          setUpdateTable(true);
          dispatch(storePriceDetailsErrors([]));
        }}
        onCancel={() => {
          setOpenCancel(false);
        }}
      />

      <SaveCancelPopup
        open={deletePopup}
        data-testid='deletePopup'
        title='Delete'
        moduleName='the selected record'
        onConfim={() => {
          DeleteRow(deletedRowInfo, updatedPage, pageCountwithDetails);
        }}
        onCancel={() => {
          setDeletePopup(false);
        }}
      />
      <Spinner load={loading} />
      <CustomSeparator
        parent1='Maintain'
        parent2='Maintain  Rebate Price Details'
      />
      <DisplaySuccessMessages successMessages={successMessages} />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <Box className='alone-pagination mb-2'>
        <Box>
          <Button
            title='Previous '
            className='btns rotate-left'
            data-testid='uc-paginate-arrow-left'
            type='button'
            onClick={clickPrevious}
            disabled={
              !(
                claimPageDetails?.pageCount > 1 &&
                !disableBtn &&
                errorMessages.length === 0
              )
            }
          >
            <SVGComponent iconName='Icon-arrow' />
            <span className='hide-elm'>Previous</span>
          </Button>
        </Box>
        <Box>
          <label className='m-0' htmlFor='paginate-count'>
            <TextField
              id='paginate-count'
              data-testid='uc-input-paginate'
              variant='outlined'
              className='searchInput input-count'
              size='small'
              value={
                claimPageDetails?.pageCount === 0
                  ? ''
                  : claimPageDetails?.pageCount
              }
              onChange={(e) => handlePage(e)}
              onBlur={onBlurPage}
            />
          </label>
        </Box>
        <Box className='btns'>Of {totalCount}</Box>
        <Box>
          <Button
            title='Next '
            className='btns rotate-right ml-0'
            data-testid='uc-paginate-arrow-right'
            type='button'
            onClick={clickNextRow}
            disabled={
              !(
                claimPageDetails?.pageCount !== totalCount &&
                !disableBtn &&
                errorMessages.length === 0
              )
            }
          >
            <SVGComponent iconName='Icon-arrow' />
            <span className='hide-elm'>Next</span>
          </Button>
        </Box>
      </Box>
      {!fullScreenView1 && !fullScreenView2 && (
        <div className='row'>
          <div
            className='col-12 mui-custom-form no-margin'
            style={{ width: '100%' }}
          >
            <fieldset className='custom-fieldset custom-height'>
              <legend className='d-none' />
              <div className='form-wrapper db'>
                <div className='row'>
                  <div className='col-3 col-md-4 col-sm-6 col-lg-4 col-xl-3 mb-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          data-testid='plantype'
                          id='plantype'
                          label='Plan Type'
                          fullWidth
                          disabled
                          placeholder=''
                          value={claimPageDetails?.inputList?.planTypeCd}
                          inputProps={{ maxLength: 38, id: 'plantype' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-3 col-md-4 col-sm-6 col-lg-4 col-xl-3 mb-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          data-testid='plantypedescription'
                          id='plantypedescription'
                          label='Plan Type Description'
                          fullWidth
                          disabled
                          placeholder=''
                          value={claimPageDetails?.inputList?.shortDescr}
                          inputProps={{ maxLength: 38 }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-3 col-md-4 col-sm-6 col-lg-4 col-xl-3 mb-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          data-testid='rebateprogramcode'
                          id='rebateprogramcode'
                          label='Rebate Program Code'
                          fullWidth
                          disabled
                          placeholder=''
                          value={claimPageDetails?.inputList?.rpc}
                          inputProps={{
                            maxLength: 38,
                            id: 'rebateprogramcode',
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-3 col-md-4 col-sm-6 col-lg-4 col-xl-3 mb-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          data-testid='rebateprogramdesc'
                          id='rebateprogramdesc'
                          label='Rebate Program Code Description'
                          fullWidth
                          disabled
                          placeholder=''
                          value={claimPageDetails?.inputList?.shortDescr}
                          inputProps={{
                            maxLength: 38,
                            id: 'rebateprogramdesc',
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-3 col-md-4 col-sm-6 col-lg-4 col-xl-3 mb-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          data-testid='manufacturerid'
                          id='manufacturerid'
                          fullWidth
                          disabled
                          label='Manufacturer ID'
                          placeholder=''
                          value={claimPageDetails?.inputList?.mfgId}
                          inputProps={{ maxLength: 38, id: 'manufacturerid' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-3 col-md-4 col-sm-6 col-lg-4 col-xl-3 mb-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          data-testid='quarter'
                          id='quarter'
                          fullWidth
                          disabled
                          label='Quarter'
                          placeholder=''
                          value={claimPageDetails?.inputList?.asQtr}
                          inputProps={{ maxLength: 38, id: 'quarter' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-3 col-md-4 col-sm-6 col-lg-4 col-xl-3 mb-3'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column'>
                        <TextField
                          data-testid='drugfamilyname'
                          id='drugfamilyname'
                          fullWidth
                          disabled
                          label='Drug Family Name'
                          placeholder=''
                          value={claimPageDetails?.inputList?.familyName}
                          inputProps={{ maxLength: 38, id: 'drugfamilyname' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-12 p-0'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column tbl-help-text'>
                        <TextField
                          data-testid='drugfamilydesc'
                          id='drugfamilydesc'
                          fullWidth
                          disabled
                          label='Drug Family Description'
                          placeholder=''
                          value={claimPageDetails?.inputList?.familyDescr}
                          inputProps={{
                            minHeight: 80,
                            maxLength: 38,
                            id: 'drugfamilydesc',
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className='col-12 my-4 text-center'>
            <div className='row align-items-baseline'>
              <div className='col-6'>
                <div className='row'>
                  <div className='col-6'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column tbl-help-text'>
                        <TextField
                          data-testid='ndc'
                          id='ndc'
                          fullWidth
                          disabled
                          label='NDC'
                          placeholder=''
                          value={`${pageCountwithDetails?.inputList?.labelerCode}-${pageCountwithDetails?.inputList?.productCode}-${pageCountwithDetails?.inputList?.packageSize}`}
                          inputProps={{
                            minHeight: 80,
                            maxLength: 38,
                            id: 'ndc',
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-6 p-0'>
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='mui-custom-form with-select input-md override-width-95 d-flex flex-column tbl-help-text'>
                        <TextField
                          data-testid='ndcname'
                          id='ndcname'
                          fullWidth
                          disabled
                          label='NDC Name'
                          placeholder=''
                          value={claimPageDetails?.inputList?.drugName}
                          inputProps={{
                            minHeight: 80,
                            maxLength: 38,
                            id: 'ndcname',
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-6 btn-wrapper d-flex justify-content-end'>
                <Button
                  className='btn btn-success btn-save'
                  data-testid='saveButton'
                  disabled={buttonDisable.save}
                  onClick={() => {
                    const getRows = checkStartQtr(
                      updatedPage[pageCountwithDetails?.pageCount]
                    );

                    if (getRows?.length === 1) {
                      setOnblur(true);
                      dispatch(errorControl({ err: true }));
                      validations(updatedPage[pageCountwithDetails?.pageCount]);
                      dispatch(onChangePage(true));
                    } else {
                      dispatch(errorControl({ err: false }));
                      setClickOncloseTabBtn(false);
                      setOpen(true);
                    }
                  }}
                >
                  {' '}
                  <SVGComponent iconName='Icon-awesome-save' />
                  Save
                </Button>
                <Button
                  className='btn btn-cancel'
                  data-testid='cancelButton'
                  disabled={buttonDisable.cancel}
                  onClick={() => {
                    setOpenCancel(true);
                    setClickOncloseTabBtn(true);
                  }}
                >
                  <SVGComponent iconName='Icon-cancel' />
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      {!fullScreenView2 && (
        <div className='panel-body FRR-custom-table tbl-manufacturer-inner'>
          <TableGrid
            ref={gridRef}
            rowData={rebateProgramMethod}
            columnDefs={rebatePricingDetails}
            handleFullScreenViewClick={() => handleFullScreenView(1)}
            fullScreenView={fullScreenView1}
            gridHeight={fullScreenView1 ? '70vh' : 250}
            helpMessage=''
            enterMovesDown
            suppressCellFocus
            exportWithOtherOption
            handleGoToNdcURLLink={(data) => {
              if (data === 'ndc') getNdcData();
              else if (data === 'contract') goToContract();
              else if (data === 'manufacturer') goToManufacturer();
              else if (data === 'rebateprogram') goToRebateProgram();
              else if (data === 'drugfamily') goToDrugFamily();
              else if (data === 'jumptondc') openJumbNdc();
            }}
            handleViewDetailsForRebatePriceDetails
            data-testid='onEditingStopped'
            fileName='Rebate Price Details-Price Grid'
          />
        </div>
      )}
      {!fullScreenView1 && (
        <>
          <div className='manufacturer-checkbox flex-box-100 align-items-center float-left'>
            <FormControlLabel
              className='m-0 mt-2'
              control={<Checkbox color='primary' className='mr-2' />}
              label='Show All Quarters'
              checked={showQuartes}
              data-testid='showQuarters'
              onClick={() => {
                dispatch(showAllQuarters(!showQuartes));
              }}
            />
            <a
              role='button'
              data-testid='addBtn'
              disabled={getErrorMsgs?.length !== 0}
              className={`icon-plus float-left mr-4 ${
                getErrorMsgs?.length !== 0 && 'frr-disable-anchor'
              }`}
              onClick={() =>
                AddRow(
                  updatedPage,
                  pageCountwithDetails?.pageCount,
                  getPriceGridDetails
                )
              }
            >
              <h2 className='my-2'>Add row</h2>
            </a>
          </div>
          <div className='panel-body FRR-custom-table tbl-manufacturer-inner'>
            <TableGrid
              ref={gridRef}
              rowData={
                showQuartes ? updatedPage[pageCountwithDetails?.pageCount] : []
              }
              columnDefs={priceDetailsHeaders}
              handleFullScreenView={false}
              handleFullScreenViewClick={() => handleFullScreenView(2)}
              fullScreenView={fullScreenView2}
              gridHeight={fullScreenView2 ? '70vh' : 350}
              helpMessage={' '}
              enterMovesDown
              suppressCellFocus
              exportWithOtherOption
              handleGoToNdcURLLink={(data) => {
                if (data === 'ndc') getNdcData();
                else if (data === 'contract') goToContract();
                else if (data === 'manufacturer') goToManufacturer();
                else if (data === 'rebateprogram') goToRebateProgram();
                else if (data === 'drugfamily') goToDrugFamily();
                else if (data === 'jumptondc') openJumbNdc();
              }}
              ShowStartDateOption={false}
              handleViewDetailsForRebatePriceDetails
              data-testid='onEditingStopped2'
              fileName='Rebate Price Details-Level Grid'
              gridCall={onGridReady}
              onCellValueChanged={onCellValueChanged}
              singleClickEdit
              onCellFocused={onCellFocused}
              frameworkComponents={{
                ActionCellRender: (cellInfo) => {
                  const { pageCountwithDetails, getPriceGridDetails } =
                    useSelector((state) => state.sharedState?.PriceDetails);

                  const updatedPage = useSelector(
                    (state) =>
                      state?.sharedState?.PriceDetails?.storeUpdatedDetailsPage
                  );
                  const getErrorMsgs = useSelector(
                    (state) =>
                      state.sharedState.PriceDetails?.priceDetailErrors || []
                  );
                  const colId = cellInfo?.column?.colId || '';

                  return (
                    <div
                      className='tdCell icon-btn-group d-flex'
                      data-testid='action-column'
                    >
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
                      >
                        <Button
                          className='th-ic comment-ic'
                          variant='text'
                          onClick={() => {
                            setCorrLinkId(cellInfo && cellInfo.data.corrLinkId);
                            setShowComments(true);
                            setLinkTableName('REBATE_PRICING_DETAIL');
                            setTableName('CONTRACT_DRUG_FAMILY');
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(
                                cellInfo && cellInfo.data.corrLinkId
                              );
                              setShowComments(true);
                              setLinkTableName('REBATE_PRICING_DETAIL');
                              setTableName('CONTRACT_DRUG_FAMILY');
                            }
                          }}
                          disabled={cellInfo.data.claimCorrLinkId === null}
                        >
                          {parseInt(cellInfo.data.claimCorrLinkId, [0, 1]) ===
                          1 ? (
                            <img alt='comment' src={CommentVisibleIcon} />
                          ) : (
                            <img alt='comment' src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='add-tooltip'>Add</Tooltip>}
                      >
                        <Button
                          className='float-left'
                          data-testid='add-new-log-check'
                          aria-label='Add new log check'
                          variant='text'
                          disabled={getErrorMsgs?.length !== 0}
                          onClick={() =>
                            AddRow(
                              updatedPage,
                              pageCountwithDetails?.pageCount,
                              getPriceGridDetails
                            )
                          }
                        >
                          <SVGComponent iconName='Icon-addCircle' />{' '}
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement='bottom'
                        overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
                      >
                        <Button
                          data-testid='deleteBtn'
                          className='th-ic trash-blue'
                          aria-label='trash-blue'
                          variant='text'
                          onClick={() => {
                            setDeletePopup(true);
                            setDeletedRowInfo(cellInfo);
                          }}
                        >
                          <SVGComponent iconName='Icon-delete' />
                        </Button>
                      </OverlayTrigger>
                    </div>
                  );
                },
                TextBoxRender: (cellInfo) => {
                  const {
                    pageCountwithDetails,
                    getPriceGridDetails,
                    onchangePayload,
                  } = useSelector((state) => state.sharedState.PriceDetails);

                  const updatedPage = useSelector(
                    (state) =>
                      state?.sharedState?.PriceDetails?.storeUpdatedDetailsPage
                  );
                  const colId = cellInfo?.column?.colId || '';

                  const getErrorMsgs = useSelector(
                    (state) => state.sharedState.PriceDetails?.priceDetailErrors
                  );
                  const errControl = useSelector(
                    (state) => state.sharedState.PriceDetails?.errControl
                  );

                  const duplicateErr = [];
                  getErrorMsgs?.length > 0 &&
                    getErrorMsgs.filter((e) => {
                      if (e.field === 'duplicateStartQtr') {
                        duplicateErr.push(e.index);
                      }
                    });
                  const quarterOverlap = [];
                  getErrorMsgs?.length > 0 &&
                    getErrorMsgs.filter((e) => {
                      if (e.field === 'quarterOverlap') {
                        quarterOverlap.push(e.index);
                      }
                    });

                  const startDateGreater = [];
                   getErrorMsgs?.length > 0 &&
                  getErrorMsgs.filter((e) => {
                    if (e.field === 'startDateGreater') {
                      startDateGreater.push(e.index);
                    }
                  });

                  const invalidEndQtr = [];
                   getErrorMsgs?.length > 0 &&
                  getErrorMsgs.filter((e) => {
                    if (e.field === 'invalidEndQtr') {
                      invalidEndQtr.push(e.index);
                    }
                  });

                  const invalidLevelId = [];
                  getErrorMsgs?.length > 0 &&
                  getErrorMsgs.filter((e) => {
                    if (e.field === 'levelId') {
                      invalidLevelId.push(e.index);
                    }
                  });

                  const disableInput = (key) => {
                    if (key === 'levelId') {
                      if (
                        pageCountwithDetails?.inputList?.planTypeCd === 'COMM'
                      ) {
                        return false;
                      }
                      return true;
                    }
                    return false;
                  };
                  return (
                    <div className='form-wrapper vertical-wrapper'>
                      <div className='frr-display-hidden-label no-lbl'>
                        {colId === 'amt' ? (
                          <TextField
                            style={{ marginTop: '2px' }}
                            fullWidth
                            id={`${colId}_${cellInfo.rowIndex}`}
                            label={colId}
                            name={colId}
                            disabled={!!disableInput(colId)}
                            placeholder=''
                            className='frr-display-hidden-label amt-style'
                            value={cellInfo.value}
                            inputProps={{
                              maxLength: 22,
                              id: `${colId}_${cellInfo.rowIndex}`,
                            }}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                              startAdornment: (
                                <InputAdornment
                                  position='start'
                                  className='prefix-symbol'
                                >
                                  $
                                </InputAdornment>
                              ),
                            }}
                            onChange={(e) => {
                              if (
                                e.target.value &&
                                e.target.value.includes('.')
                              ) {
                                const rx = /^[0-9]{0,9}(\.[0-9]{0,6})?$/;
                                if (rx.test(e.target.value)) {
                                  onChangeGrid(e, cellInfo);
                                }
                              } else {
                                const rx_without = /^[0-9]{0,9}?$/;
                                if (rx_without.test(e.target.value)) {
                                  onChangeGrid(e, cellInfo);
                                }
                              }
                            }}
                            onBlur={(e) => {
                              setOnblur(true);
                              dispatch(onChangePage(true));
                            }}
                          />
                        ) : (
                          <TextField
                            style={{ marginTop: '2px' }}
                            fullWidth
                            required
                            id={colId + cellInfo.rowIndex}
                            label={colId}
                            name={colId}
                            disabled={!!disableInput(colId)}
                            placeholder=''
                            className={`${
                              colId === 'startQtr'
                                ? (updatedPage[
                                    pageCountwithDetails?.pageCount
                                  ] &&
                                    updatedPage[
                                      pageCountwithDetails?.pageCount
                                    ][cellInfo.rowIndex] &&
                                    errControl?.err &&
                                    updatedPage[
                                      pageCountwithDetails?.pageCount
                                    ][cellInfo.rowIndex].startQtr === '') ||
                                  (errControl?.err &&
                                    !validateQtr(
                                      updatedPage,
                                      pageCountwithDetails?.pageCount,
                                      cellInfo.rowIndex
                                    )) ||
                                  duplicateErr.includes(
                                    Number(cellInfo.rowIndex) + 1
                                  ) ||
                                  quarterOverlap.includes(
                                    Number(cellInfo.rowIndex) + 1
                                  ) ||
                                  startDateGreater.includes(
                                    Number(cellInfo.rowIndex) + 1
                                  )
                                  ? 'td-active-cell tBill-validate frr-display-hidden-label'
                                  : 'frr-display-hidden-label'
                                : colId === 'endQtr'
                                ? updatedPage[
                                    pageCountwithDetails?.pageCount
                                  ] &&
                                  updatedPage[pageCountwithDetails?.pageCount][
                                    cellInfo.rowIndex
                                  ] &&
                                  updatedPage[pageCountwithDetails?.pageCount][
                                    cellInfo.rowIndex
                                  ].endQtr !== '' &&
                                  invalidEndQtr.includes(
                                    Number(cellInfo.rowIndex) + 1
                                  )
                                  ? 'td-active-cell tBill-validate frr-display-hidden-label'
                                  : 'frr-display-hidden-label'
                                : colId === 'levelId' &&
                                  invalidLevelId.includes(
                                    Number(cellInfo.rowIndex) + 1
                                  )
                                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                                : 'frr-display-hidden-label'
                            } ${colId === 'amt' ? 'amt-style' : ''}`}
                            inputProps={{
                              maxLength: colId ? getLength(colId) : 15,
                            }}
                            value={cellInfo.value}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={
                              colId === 'amt'
                                ? {
                                    inputComponent: NumberFormatCustom,
                                    startAdornment: (
                                      <InputAdornment
                                        position='start'
                                        className='prefix-symbol'
                                      >
                                        $
                                      </InputAdornment>
                                    ),
                                  }
                                : null
                            }
                            // type={colId === 'amt' ? 'number': 'text'}
                            onChange={(e) => {
                              if (e.target.name === 'amt') {
                                if (
                                  e.target.value &&
                                  e.target.value.includes('.')
                                ) {
                                  const rx = /^[0-9]{0,9}(\.[0-9]{0,6})?$/;
                                  if (rx.test(e.target.value)) {
                                    onChangeGrid(e, cellInfo);
                                  }
                                } else {
                                  const rx_without = /^[0-9]{0,9}?$/;

                                  if (rx_without.test(e.target.value)) {
                                    onChangeGrid(e, cellInfo);
                                  }
                                }
                              } else {
                                onChangeGrid(e, cellInfo);
                              }
                            }}
                            onBlur={(e) => {
                              gridTwoOnBlur(
                                e,
                                cellInfo,
                                getPriceGridDetails,
                                onchangePayload
                              );
                            }}
                          />
                        )}
                      </div>
                    </div>
                  );
                },
              }}
            />
          </div>
        </>
      )}
      <CommonModal
        open={jumbPopup}
        viewAction
        viewHeader
        data-testid='commonModal'
        className='dialog-420 rr-dialog-css'
        onOk={() => moveToNdc()}
        okTitle='Ok'
        onClose={() => {
          seJumbPopup(false);
        }}
        closeTitle='Cancel'
        modalTitle='Jump To NDC'
        childrenComponent={
          <div className='mui-custom-form input-md frr-drugStart'>
            <TextField
              name='rebateProgram'
              fullWidth
              select
              required
              label='Jump to which NDC'
              inputProps={{ maxLength: 11, id: 'jumb_to_ndc' }}
              InputLabelProps={{
                shrink: true,
              }}
              value={jumbNdc}
              onChange={(e) => setJumbNdc(e.target.value)}
              //   onBlur={handleOnBlur}
            >
              <MenuItem key='' value='-1' className='frr-dropdown-blank-item' />
              {allNdcList?.length > 0
                ? allNdcList?.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.value}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
            {/* </div> */}
          </div>
        }
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTableName}
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={null}
        />
      ) : null}
    </div>
  );
};

export default RebatePriceDetails;
